/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SecurityAnalyticsProcessesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * API endpoint to get Omni SSO embed URL
   * @returns any Omni SSO embed URL
   * @throws ApiError
   */
  public getApiServicesecurityProcessesAnalytics(): CancelablePromise<{
    data?: {
      embedUrl?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/processes/analytics',
    });
  }

}
